import { createSelector } from '@reduxjs/toolkit';

import { UPLOAD_END, UPLOAD_PROGRESS, UPLOAD_START } from 'FRONTEND/actions/constants';

const initialState = {
  progressMap: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_START: {
      return {
        ...state,
        progressMap: {
          ...state.progressMap,
          [action.payload.id]: {
            id: action.payload.id,
            secondsRemaining: Infinity,
          },
        },
      };
    }

    case UPLOAD_PROGRESS: {
      if (!state.progressMap[action.payload.id]) {
        return state;
      }
      return {
        ...state,
        progressMap: {
          ...state.progressMap,
          [action.payload.id]: {
            ...state.progressMap[action.payload.id],
            progress: action.payload.progress,
            secondsRemaining: action.payload.secondsRemaining,
          },
        },
      };
    }

    case UPLOAD_END: {
      const newProgressMap = { ...state.progressMap };
      delete newProgressMap[action.payload.id];
      return {
        ...state,
        progressMap: newProgressMap,
      };
    }

    default:
      return state;
  }
};

export const selectUploadInProgress = createSelector(
  (state) => state.upload.progressMap,
  (progressMap) => (
    Object.entries(progressMap).map(([id, progressSnackar]) => ({
      ...progressSnackar,
      id,
    })).filter(({ progress }) => progress != null)
  ),
);
